// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__2GbgI","checkbox":"Checkbox_style_checkbox__0t45D","rotate":"Checkbox_style_rotate__CCtg6"};